import './App.css';
import { useState } from 'react';
import { useMeals } from './Hooks/useMeals';
import { useFavorites } from './context';
import FavoriteList from './components/FavoriteList';
import MealCard from './components/MealCard';
import MealModal from './components/MealModal';

const DEFAULT_SEARCH = 'chicken';

function App() {
  const [searchTerm, setSearchTerm] = useState(DEFAULT_SEARCH);
  const [activeMealId, setActiveMealId] = useState(null);

  const { favorites, toggleFavorite, isFavorite } = useFavorites();
  const { data: meals = [], isLoading, isError, error } = useMeals(searchTerm);

  const handleSearchSubmit = (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    const value = form.search.value.trim();
    setSearchTerm(value || DEFAULT_SEARCH);
  };

  const handleOpenDetails = (mealId) => {
    setActiveMealId(mealId);
  };

  const handleCloseModal = () => {
    setActiveMealId(null);
  };

  return (
    <div className="App">
      <header className="App-header">
        <h1>Menu App</h1>
        <form className="search-form" onSubmit={handleSearchSubmit}>
          <input name="search" defaultValue={searchTerm} placeholder="Search meals by name" />
          <button type="submit">Search</button>
        </form>
      </header>

      <main className="app-main">
        <section className="meals-section">
          <h2>Meals</h2>

          {isLoading ? (
            <p className="status-message">Loading meals…</p>
          ) : isError ? (
            <p className="status-message error">Error: {error.message}</p>
          ) : meals.length === 0 ? (
            <p className="status-message">No meals found. Try another search.</p>
          ) : (
            <div className="meals-grid">
              {meals.map((meal) => (
                <MealCard
                  key={meal.idMeal}
                  meal={meal}
                  onShowDetails={() => handleOpenDetails(meal.idMeal)}
                  onToggleFavorite={() => toggleFavorite(meal)}
                  isFavorite={isFavorite(meal.idMeal)}
                />
              ))}
            </div>
          )}
        </section>

        <aside className="sidebar">
          <FavoriteList onOpenDetails={(meal) => handleOpenDetails(meal.idMeal)} />
        </aside>
      </main>

      <MealModal
        mealId={activeMealId}
        onClose={handleCloseModal}
        onToggleFavorite={toggleFavorite}
        isFavorite={activeMealId ? isFavorite(activeMealId) : false}
      />
    </div>
  );
}

export default App;
